/**
 * Storyella 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'

/**
 * Storyella 品牌特定主题配置
 */
export const theme = {
  popupTagBgColor: '#EFF3FA',
  popupTagColor: '#65686F',
  popupTagActiveColor: '#FFFFFF',

  filterBgColor: '#EFF3FA',
  filterActiveBgColor: '#FFF0F3',
  filterColor: '#65686F',
  filterActiveColor: '#FF4774',
} as const

export const tagsConfig: TagsPageConfig = {
  theme,
  texts: tagsCommonConfig.texts,
}
